import _values from 'lodash/values';
import type { ComponentsUnionType } from '@unifyapps/defs/types/block';
import { useInterfaceStore } from '../context';
import { useBlockFromPage } from '../hooks';
import type { BuilderInterfaceStoreSelectors } from './selectors';

export const useGetInterfaceStoreState = () => {
  return {
    getInterfaceStoreState: useBuilderInterfaceStore().getState,
  };
};

export const useBuilderInterfaceStore = () => {
  return useInterfaceStore<BuilderInterfaceStoreSelectors>();
};

export const useActivePropertyPanelHistory = () => {
  const propertyPanelHistory = useBuilderInterfaceStore().use.propertyPanel().history;
  return {
    activeState: propertyPanelHistory[propertyPanelHistory.length - 1],
    historyLength: propertyPanelHistory.length,
  };
};

export const useIsActiveInterfacePageDirty = () => {
  const activeInterfacePageId = useInterfaceStore().use.activeInterfacePageId();
  const dirtyPages = useBuilderInterfaceStore().use.dirtyPages();
  return dirtyPages.has(activeInterfacePageId);
};

export const useActiveBlockFromPage = <T = ComponentsUnionType>() => {
  const blockId = useBuilderInterfaceStore().use.activeBlockId();
  return useBlockFromPage<T>({ blockId });
};
